import { render } from "./AmericanFlag.vue?vue&type=template&id=ae2fdf70"
import script from "./AmericanFlag.vue?vue&type=script&lang=js"
export * from "./AmericanFlag.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__